<div>
  <nb-card>
    <nb-card-header>
      <div i18n="@@InputAssessmentData" class="subtitle">
        Input CheckIn Data
      </div>
    </nb-card-header>
<!--  [formGroup]="AssessmentForm" -->
    <nb-card-body [nbSpinner]="isLoading">

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group row">
            <ul class="col-sm-12 basic_list_informations">
              <li i18n="@@Patient">Client</li>
              <li>{{PatientName}}</li>
            </ul>
          </div>

          <div class="form-group row" *ngIf="!IsSelfCheckin">
            <ul class="col-sm-12 basic_list_informations">
              <li i18n="@@Dates">Dates</li>
              <li>{{StartDate}} - {{EndDate}}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <form *ngIf="formlyForm" [formGroup]="form">
            <formly-form [options]="options" [model]="model" [fields]="formlyForm" [form]="form"></formly-form>
          </form>


        </div>
      </div>
      <div *ngIf="!isLoading && isImageProgressUpload">
      <app-image-upload
      [label]="'Front Image'"
      [imageSrc]="model.progressImageUrl"
      (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImage)"
      (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImage)"
      >
    </app-image-upload>
    <app-image-upload
      [label]="'Back Image'"
      [imageSrc]="model.progressImageLeftUrl"
      (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImageLeft)"
      (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImageLeft)"
      >
    </app-image-upload>

    <app-image-upload
      [label]="'Side Image'"
      [imageSrc]="model.progressImageRightUrl"
      (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImageRight)"
      (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImageRight)"
      >
    </app-image-upload>
      </div>

    </nb-card-body>

    <nb-card-footer>
      <table class="float-left">
        <tr>
          <td>
            <!-- (click)="SaveAssessment()" -->
            <button i18n="@@SaveAssessment" *ngIf="!HideSaveButton" [nbSpinner]="isLoading" class="btn-circle btn-xl btn-main" nbButton type="submit"
            (click)="submit()" [disabled]="!form.valid||isLoading">Save CheckIn</button></td>
        </tr>
      </table>
    </nb-card-footer>
  </nb-card>

  <br /><br /><br /><br /><br />

</div>
